import ApplicationPreviewOffers from './ApplicationPreviewOffers.component';

export default ApplicationPreviewOffers;
